// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Goto__Wrapper_31h1H","Title":"Goto__Title_2wmHf","Link":"Goto__Link_1nS5Q"};